// Where a brand lead came from, read from its `source`:
// - app        `app:onboarding`, `app:sidebar`, `app` (the in-app form)
// - site       `site:/marcas/campanha` (autoclipper.live)
// - marcas     `lp-competicao-marcas` (marcas.autoclipper.live)
// - other      anything else
// Mirrors ../autoclipper-backend/src/lib/brandLeads/leadOrigin.js; both run the
// byte-identical __tests__/fixtures/leadOriginTestVectors.json.
export const LEAD_ORIGIN_GROUPS = ['app', 'site', 'marcas', 'other'] as const;

export type LeadOriginGroup = (typeof LEAD_ORIGIN_GROUPS)[number];

export interface LeadOrigin {
  readonly group: LeadOriginGroup;
  readonly label: string;
}

const APP_ORIGIN_LABELS: Record<string, string> = { onboarding: 'onboarding', sidebar: 'menu' };

export function describeLeadOrigin(source: string | null | undefined): LeadOrigin {
  const value = typeof source === 'string' ? source : '';
  if (value === 'app' || value === 'app:') return { group: 'app', label: 'App' };
  if (value.startsWith('app:')) {
    const origin = value.slice(4);
    const name = Object.prototype.hasOwnProperty.call(APP_ORIGIN_LABELS, origin)
      ? APP_ORIGIN_LABELS[origin]
      : origin;
    return { group: 'app', label: `App · ${name}` };
  }
  if (value.startsWith('site:')) {
    return { group: 'site', label: `autoclipper.live${value.slice(5)}` };
  }
  if (value === 'lp-competicao-marcas') {
    return { group: 'marcas', label: 'marcas.autoclipper.live' };
  }
  return { group: 'other', label: value };
}

const UTM_PARTS = ['utm_source', 'utm_medium', 'utm_campaign'] as const;

/** "instagram · paid · lancamento" from a lead's stored utm, or null. */
export function describeLeadUtm(utm: unknown): string | null {
  if (!utm || typeof utm !== 'object' || Array.isArray(utm)) return null;
  const record = utm as Record<string, unknown>;
  const parts = UTM_PARTS
    .map((key) => record[key])
    .filter((part): part is string => typeof part === 'string' && part.trim() !== '')
    .map((part) => part.trim());
  return parts.length ? parts.join(' · ') : null;
}
